import passwordHide from 'assets/password-hide.svg';
import passwordShow from 'assets/password-show.svg';
import { TextInput } from 'components/ui';
import PropType from 'prop-types';
import React from 'react';

export class PasswordField extends React.PureComponent {
  static propTypes = {
    show: PropType.bool.isRequired,
    onPasswordChange: PropType.func.isRequired,
    onShowChange: PropType.func.isRequired
  };

  render() {
    const { classes, onShowChange, onPasswordChange, show, ...props } =
      this.props;

    const alt = show ? 'hide password' : 'show password';
    const src = show ? passwordShow : passwordHide;
    const type = show ? 'text' : 'password';

    return (
      <TextInput
        icon={<img alt={alt} src={src} />}
        onChange={onPasswordChange}
        onIconClick={onShowChange}
        type={type}
        {...props}
      />
    );
  }
}

export default PasswordField;
